import { RadioGroup, Radio } from 'rsuite';

import "./basicRadioGroup.css";

export default function BasicRadioGroup({label, data, defaultValue, style, ...props}) {
    return (
        <div className='radioGroupWrapper fluid'>
            <span className='radioGroupLabel paragraph-12R'>{label}</span>
            <RadioGroup className={'radioGroup' + (style ? '' : 'fluid')} name="radio-group-inline-picker" style={style} {...props} inline appearance="picker" defaultValue={defaultValue}>
                {data.map((item, index) => <Radio key={index} value={item.value}>{item.label}</Radio>)}
            </RadioGroup>
        </div>
    )
}